import React, { useMemo } from 'react';
import { LigneProduit } from '../../pages/Achats/components/forms/types';
import AdditionalDataLine from './AdditionalDataLine';

type AdditionalQuoteLineProps = {
    lineProductQuote: LigneProduit;
};

const AdditionalQuoteLine: React.FunctionComponent<AdditionalQuoteLineProps> = function ({
    lineProductQuote,
}: AdditionalQuoteLineProps) {
    const data: Array<string> = useMemo(
        () => [lineProductQuote.rubriqueFacturation?.code || '?', lineProductQuote.libelle || '?'],
        [lineProductQuote.libelle, lineProductQuote.rubriqueFacturation?.code],
    );

    return (
        <AdditionalDataLine
            libelle="Devis"
            data={data}
        />
    );
};

export default AdditionalQuoteLine;
